import { Phone, Instagram, ArrowUpLeft } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useContact } from "@/lib/contact";

const WhatsAppIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
  </svg>
);

export const ContactSection = () => {
  const CONTACT = useContact();
  const CHANNELS = [
    {
      testid: "contact-phone-button",
      href: CONTACT.phoneLink,
      icon: <Phone className="h-6 w-6" />,
      title: "اتصل بنا",
      cta: "اتصل بنا",
      subtitle: <span dir="ltr">{CONTACT.phoneDisplay}</span>,
      accent: "hover:border-[#C80000]/55 hover:shadow-[0_24px_60px_-24px_rgba(200,0,0,0.5)]",
      iconBg: "bg-[#C80000]/15 text-brand",
    },
    {
      testid: "contact-whatsapp-button",
      href: CONTACT.whatsapp,
      icon: <WhatsAppIcon />,
      title: "تواصل معنا عبر واتساب",
      cta: "ابدأ المحادثة",
      subtitle: <span dir="ltr">{CONTACT.phoneDisplay}</span>,
      accent: "hover:border-[#25D366]/50 hover:shadow-[0_24px_60px_-24px_rgba(37,211,102,0.35)]",
      iconBg: "bg-[#25D366]/15 text-[#25D366]",
    },
    {
      testid: "contact-instagram-button",
      href: CONTACT.instagram,
      icon: <Instagram className="h-6 w-6" />,
      title: "تابعنا على إنستقرام",
      cta: "تابعنا",
      subtitle: <span dir="ltr">{CONTACT.instagramHandle}</span>,
      accent: "hover:border-[#dc2743]/50 hover:shadow-[0_24px_60px_-24px_rgba(220,39,67,0.35)]",
      iconBg: "bg-[#dc2743]/15 text-[#f09433]",
    },
  ];
  return (
  <section id="contact" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="absolute -bottom-40 -end-40 h-[480px] w-[480px] rounded-full bg-[#C80000]/10 blur-[140px]" aria-hidden="true" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading caption="تواصل معنا" title="يسعدنا خدمتكم — اختر طريقة التواصل" />
      <div className="grid sm:grid-cols-3 gap-6">
        {CHANNELS.map((c, i) => (
          <Reveal key={c.testid} delay={0.1 * i}>
            <a
              href={c.href}
              target={c.href.startsWith("http") ? "_blank" : undefined}
              rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined}
              data-testid={c.testid}
              className={`group flex h-full flex-col rounded-3xl border border-slate-200 bg-[#FFFFFF] p-8 transition-all duration-500 hover:-translate-y-2 ${c.accent}`}
            >
              <div className={`flex h-14 w-14 items-center justify-center rounded-2xl ${c.iconBg} transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6`}>
                {c.icon}
              </div>
              <h3 className="mt-6 text-lg sm:text-xl font-bold text-[#1A1A1E]">{c.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{c.subtitle}</p>
              <span className="mt-auto pt-6 inline-flex items-center gap-2 text-xs font-bold text-brand">
                {c.cta}
                <ArrowUpLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1 group-hover:-translate-y-1" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
